import { ChangeDetectorRef, Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { SmallNavigationService } from 'app/core/services/small-navigation-sevice.service';
import { SearchComponent } from 'app/layout/common/search/search.component';
import { PageModeTabComponent } from 'app/layout/common/page-mode-tab/page-mode-tab.component';
import { LayoutService } from 'app/layout/layout.service';
import { map, Subject, take, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterComponent } from 'app/layout/common/actions/filter/filter.component';
import { NotificationsComponent } from 'app/layout/common/actions/notifications/notifications.component';
import { CommonModule } from '@angular/common';
import { BadgeComponent } from '../actions/badge/badge.component';
import { UserIconComponent } from '../actions/user-icon/user-icon.component';
import { FilterService } from 'app/main/filter-component/filter.service';
import { SchedulingSettingComponent } from 'app/main/pop-ups/scheduling-setting/scheduling-setting.component';
import { PopupDialogQueueService } from 'app/popup-dialog-queue.service';
import { CalendarService } from 'app/main/plus/calendar/calendar.service';
import { ROUTE_CONFIGS} from  'app/core/services/small-navigation-sevice.service';
import { CandidatService } from 'app/main/plus/candidats/candidat/candidat.service';
import { AgentsStateService } from 'app/core/store/agents/agents.state.service';
import { PlanningPopupComponent } from "app/main/pop-ups/planning-popup/planning-popup.component";
import { NewFeatureStylingDirective } from 'app/shared/directives/new-feature-styling.directive';
import { BulkSchedulingStateService } from 'app/main/plus/calendar/bulk-scheduling.state.service';
import { TranslocoModule, TRANSLOCO_SCOPE, TranslocoService } from '@ngneat/transloco';
@Component({
  selector: 'top-nav-small',
  imports: [
    CommonModule,
    SearchComponent,
    FilterComponent,
    NotificationsComponent,
    PageModeTabComponent,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatDividerModule,
    MatBadgeModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    UserIconComponent,
    NewFeatureStylingDirective,
    TranslocoModule
  ],
  templateUrl: './top-nav-small.component.html',
  styleUrls: ['./top-nav-small.component.scss'],
  standalone: true,
  providers: [
  {
    provide: TRANSLOCO_SCOPE,
    useValue: { scope: 'calender', alias: 'calender' },
    multi: true
  },
  {
    provide: TRANSLOCO_SCOPE,
    useValue: { scope: 'permissions', alias: 'permissions' },
    multi: true

  },
  {
    provide: TRANSLOCO_SCOPE,
    useValue: { scope: 'service-list', alias: 'service-list' },
    multi: true
  },
  {
    provide: TRANSLOCO_SCOPE,
    useValue: { scope: 'referral', alias: 'referral' },
    multi: true

  }
]
})
export class TopNavSmallComponent implements OnInit {
  notificationCount: number = 0;
  selectedTab: number = 0;
  isSearchVisible: boolean = false;
  @ViewChild('searchComp') searchComp: any;
  @ViewChild('mobileDatePicker') mobileDatePicker!: MatDatepicker<Date>;
  
  /**
   * The date bound to the hidden mobile datepicker input, mirroring the date the
   * calendar shows. Material only emits `dateChange` when the picked date differs
   * from the picker's own selection, so a stale value swallows the selection.
   */
  get mobilePickerDate(): Date { return this._calendarService.currentViewDate(); }
  isUnderBulkBreakpoint = window.innerWidth <= 599;
  currentDirection: 'rtl' | 'ltr' = 'ltr';

  // View options for the view menu
  viewOptions$: any = null;
  // Expose service signals through getter methods
  get title() { return this.navService.title; }
  get titleKey() { return this.navService.titleKey; }
  get badge() { return this.navService.badge; }
  get avatar() { return this.navService.avatar; }
  get customActions() { return this.navService.customActions; }
  get showCustomActions() { return this.navService.showCustomActions; }
  get showSearchIcon() { return this.navService.showSearchIcon; }
  get showFilterToggle() { return this.navService.showFilterToggle; }
  get showNotificationToggle() { return this.navService.showNotificationToggle; }
  get showPageHeader() { return this.navService.showPageHeader; }
  get showImprimerIcon() { return this.navService.showImprimerIcon; }
  get showMenuIcon() { return this.navService.showMenuIcon; }
  get showGoBackIcon() { return this.navService.showGoBackIcon; }
  get showPageTabMode() { return this.navService.showPageTabMode; }
  get backArrowIcon() { return this.translocoService.getActiveLang() === 'ar' ? 'arrow_forward' : 'arrow_back'; }

  mobileHeaderTitle(): string {
    const key = this.titleKey();
    const translated = key ? this.translocoService.translate(key) : this.title();
    if (this.isUnderBulkBreakpoint && this.translocoService.getActiveLang() === 'tn') {
      return translated.replace(/\s*\([^)]*[\u0600-\u06FF][^)]*\)/g, '').trim();
    }
    return translated;
  }
  

  private _unsubscribeAll: Subject<any>;

  private _popupDialogService = inject(PopupDialogQueueService);
  public _calendarService = inject(CalendarService);
  private _bulkSchedulingStateService = inject(BulkSchedulingStateService);
  constructor(
    private _fuseSidebarService: FuseSidebarService,
    private layoutService: LayoutService,
    private navService: SmallNavigationService,
    private router: Router,
    private _filterService: FilterService,
    private _activatedRoute: ActivatedRoute,
    private candService: CandidatService,
    private _agentsStateService: AgentsStateService,
    private translocoService: TranslocoService,
    private changeDetectorRef: ChangeDetectorRef,
          
    ) {
      this._unsubscribeAll = new Subject();
    this._filterService.toggleFilterVisibility(true);
  
    }

  ngOnInit(): void {
    this.currentDirection = getComputedStyle(document.body).direction === 'rtl' ? 'rtl' : 'ltr';
    this.translocoService.langChanges$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.currentDirection = getComputedStyle(document.body).direction === 'rtl' ? 'rtl' : 'ltr';
      this.changeDetectorRef.markForCheck();
    });

    this.viewOptions$ = this._calendarService.daysToShowPerWeekView.pipe(
      takeUntil(this._unsubscribeAll),
      map((days: number) => [
        { id: 'month', title: 'calender.month' },
        { id: 'threedays', title: 'calender.three_days' },
        { id: 'week', title: 'calender.week' },
        { id: 'day', title: 'calender.day' }
        // 'Agents' is handled as a separate menu item below the divider
      ])
    );

    // Initialize notification count
    this.notificationCount = 3; // Example value
    
    // Set default view to 'day' if no view is selected
    if (!this._calendarService.viewModeSignal()) {
      this._calendarService.viewModeSignal.set('day');
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.isUnderBulkBreakpoint = window.innerWidth <= 599;
  }

  isBulkMobileActive(): boolean {
    return this.router.url.startsWith('/calendar')
      && this.isUnderBulkBreakpoint
      && this._bulkSchedulingStateService.isActive();
  }

  triggerBulkExit(): void {
    this._calendarService.bulkModeTopBarAction.set('exit');
  }

  triggerBulkSave(): void {
    this._calendarService.bulkModeTopBarAction.set('save');
  }
 isDateTitle(): boolean {
  return this.router.url.startsWith('/calendar') && !!this.title()?.trim();
}

  /**
   * When the title is clicked on calendar pages, open the touch-UI datepicker.
   */
  onTitleClick(): void {
    if (this.isDateTitle() && this.mobileDatePicker) {
      this.mobileDatePicker.open();
    }
  }

  /**
   * When a date is selected in the mobile datepicker, notify the calendar
   * component via the CalendarService signal.
   */
  onMobileDateSelected(date: Date): void {
    if (!date) return;
    // This picker uses the native date adapter, the rest of the app the moment one.
    const normalizedDate = date instanceof Date ? date : new Date(date as any);
    if (isNaN(normalizedDate.getTime())) return;

    this._calendarService.datePickerSelected.set(normalizedDate);
  }
  
  


  /**
       * Toggle sidebar open
       *
       * @param key
       */
    toggleSidebarOpen(key): void {
      if (!this._fuseSidebarService.getSidebar(key).opened) {
        this.layoutService.MarkQuestionsAsReaded().subscribe(() => {
        });
      }
      this._fuseSidebarService.getSidebar(key).toggleOpen();
      // susbscribe to toggleOpene quickPanel for close if from the intern of the panel 
      this.layoutService.quickPanelToggleOpen.pipe(take(1)).subscribe((res) => {
        if (res[0]) {
          this._fuseSidebarService.getSidebar(key).close();
        }
      });
    }



    goBack(): void {
      // const isInSettings = this.navService.currentUrl?.startsWith('/settings');
      const justLeftSettings = this.navService.isLeavingSettings;
      const justEnteredSettings = this.navService.isEnteringSettings;

      // If related to settings page, use navService goBack
      if (justEnteredSettings || justLeftSettings) {
        this.navService.goBack();
        return;
      }
      this.navService.resetToDefault();
      const segments = this.router.url.split('/')
        .filter(segment => segment)
        .map(segment => segment.split('?')[0]);

      // Build the current path progressively to check against configs
      const currentPath = '/' + segments.join('/');
      const basePathWithoutId = '/' + segments.slice(0, -1).join('/');

      const currentQueryParams = this._activatedRoute.snapshot.queryParams;

      // Determine query params to send when going back
      let queryParams = {};

      if ('selectedUpgradePeriod' in currentQueryParams) {
        queryParams = { upgrade: true };
      }

      // Check if the exact path exists in configs
      if (currentPath in ROUTE_CONFIGS) {
        const config = ROUTE_CONFIGS[currentPath];
        this.router.navigate([config.goBackNavigation || '/dashboards/analytics']);
      }
      // Check if the base path (without ID) exists for parameterized routes
      else if (basePathWithoutId in ROUTE_CONFIGS) {
        const config = ROUTE_CONFIGS[`${basePathWithoutId}/:id`];
        this.router.navigate([config.goBackNavigation || '/dashboards/analytics'], { queryParams });
      }
      // Default fallback
      else {
        this.router.navigate(['/dashboards/analytics']);
      }
    }

    ngDestroy() {
      this._filterService.toggleFilterVisibility(true);
    }

    doItemAction(action: any): void {
      if (action && typeof action === 'string') {
        // Call the method with the same name as the action string
        if (typeof this[action] === 'function') {
          this[action]();
        } else {
          console.warn(`Method '${action}' not found on component`);
        }
      } else if (typeof action === 'function') {
        action();
      }
    }



  openCalendarSettings():void {
    this._popupDialogService.openDialog(SchedulingSettingComponent, {
      panelClass: ["common-dialog-style", "sc-setting-d-style"],
    }, () => {});
  }

  /**
   * Handle view mode selection from the menu
   * @param viewMode - The selected view mode ('month', 'week', or 'day')
   */
  changeView(viewMode: 'month' | 'week' | 'threedays' | 'day' | 'agents' ): void {
    console.log(`Changing view to: ${viewMode}`);
    this._calendarService.viewModeSignal.set(viewMode);
  }

  printPlanning(): void {
    this.candService.getCandidats().subscribe((data) => {
      this._popupDialogService.openDialog(PlanningPopupComponent, {
        panelClass: ["common-dialog-style", "planning-popup"],
        width: "400px",
        data: {
          moniteurs: this._agentsStateService.agents(),
          candidats: data,
        },
      });
    });
  }

  editCandidateDetails(): void {
    this.router.navigate([], {
      queryParams: { tab: 'infos' },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
  
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
